import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CreditCardValidators } from 'angular-cc-library';
import { ToastrService } from 'ngx-toastr';
import { APP_CONSTANT, AppConst } from 'src/app/core/_constants/app.constant';
import { showDuration } from 'src/app/core/_constants/helper';
import { CommonService } from 'src/app/core/_services/common/common.service';
import { LocalStorageProvider } from 'src/app/core/_services/common/storage.service';
import { ValidationService } from 'src/app/core/_services/common/validation.service';

declare var Runner: any;

export function fiveWordsValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value || '';
    const wordCount = value.trim();
    return wordCount.length > 5 ? null : { fiveWords: true };
  };
}

export function cvcValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return { required: true }; // Value is required
    }
    const isValid = /^\d{3,4}$/.test(value); // Matches only 3-4 digits
    return isValid ? null : { invalidCVC: true }; // Return error if invalid
  };
}


@Component({
  selector: 'app-online-payment',
  templateUrl: './online-payment.component.html',
  styleUrls: ['./online-payment.component.scss']
})
export class OnlinePaymentComponent implements OnInit, AfterViewInit {

  validationErrorMessage = APP_CONSTANT.VALIDATION;
  maxLength = AppConst.MAXLENGTH;
  public creditCardForm: FormGroup;
  public bankAccountForm: FormGroup;
  submitted: boolean = false;
  paymentOnline: any = 'credit';
  adminProfile: any;


  constructor(private toastr: ToastrService,public dialogRef: MatDialogRef<OnlinePaymentComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder, private storageService: LocalStorageProvider, public validationService: ValidationService) {
    this.adminProfile = this.storageService.getItem('CurrentUser')
  }


  ngOnInit(): void {
    this.creditCardForm = this.createForm();
    this.bankAccountForm = this.createBankForm();
    const emailControl = this.creditCardForm.get('email');
    if (this.data.type === 'update') {
      emailControl.setValidators([Validators.required, Validators.email]); // Add required and email validators
    } else {
      emailControl.clearValidators(); // Remove all validators
    }
    emailControl.updateValueAndValidity();
    if (this.adminProfile?.paymentGateway === 'RUNPAYMENTS') {
      this.runPay = true;
      this.creditCardForm.get('cardNumber').clearValidators();
      this.creditCardForm.get('cardCode').clearValidators();
      this.creditCardForm.updateValueAndValidity();
    }
  }

  optionChanged() {
    this.creditCardForm.reset();
    this.bankAccountForm.reset();
  }

  createBankForm() {
    return this.fb.group({
      accountType: ['', Validators.required], // checking,savings, businessChecking
      routingNumber: ['', [Validators.required, Validators.pattern('^\s*-?[0-9]{1,9}\s*$')]], //Numeric string, up to 9 digits.
      accountNumber: ['', [Validators.required, Validators.pattern('^\s*-?[0-9]{1,17}\s*$')]], //Numeric string, up to 17 digits.
      nameOnAccount: ['', [Validators.required, Validators.maxLength(22)]] // String, up to 22 characters
    })
  }



  createForm() {
    return this.fb.group({
      email: [''],
      holderName: ['', [Validators.required, fiveWordsValidator()]],
      cardNumber: ['', [Validators.required, CreditCardValidators.validateCCNumber]],
      expirationDate: ['', [Validators.required, CreditCardValidators.validateExpDate]],
      cardCode: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(4), cvcValidator()]],
    })
  }

  get f() { return this.creditCardForm.controls; }
  get g() { return this.bankAccountForm.controls; }


  close(value: Boolean) {
    this.dialogRef.close(value);
  }

  chargeSubmit() {
    this.submitted = true;
    if (this.paymentOnline == 'credit' && this.creditCardForm.valid) {
      let expDate = this.creditCardForm.value.expirationDate.split('/')[1].trim();
      expDate = expDate.length == 4 ? expDate : '20' + expDate
      const data = {
        paymentMethod: 3,
        duration: '1',
        payeeDetails: {
          card_holder_name: this.creditCardForm.value.holderName,
          creditCardNumber: this.creditCardForm.value.cardNumber.split(" ").join(''),
          expirationDate: expDate + '-' + this.creditCardForm.value.expirationDate.split('/')[0].trim(),
          cardCode: this.creditCardForm.value.cardCode
        }
      }
      if (this.runPay) {
        data['account_token'] = this.accountToken;
      }
      if (this.data.type === 'update') {
        data.payeeDetails['email'] = this.creditCardForm.value.email;
      }
      this.dialogRef.close(data)
    }
    else if (this.paymentOnline == 'bank' && this.bankAccountForm.valid) {
      const data = {
        paymentMethod: 4,
        payeeDetails: {
          ...this.bankAccountForm.value,
        },
      }
      this.dialogRef.close(data)
    }
  }

  getDuration(data) {
    return showDuration(data)
  }

  runner: any;
  accountToken: string = '';
  expiryFromRunner: string = '';
  runPay: boolean = false;
  private isTokenizing = false;
  private tokenizeTimeout: any;

  ngAfterViewInit(): void {
    if (this.adminProfile?.paymentGateway === 'RUNPAYMENTS') {
      setTimeout(() => {
        this.runner = new Runner();
        this.runner.init({
          element: "#run-form",
          publicKey: "mY4Lk4mXozbxRNh415BZaAZZ",
          cardLabel: 'Card Number',
          cvvLabel: 'CVV',
          useCvv: true,
          useExpiry: true,
          cvvFieldSelector: "#cvvId",
          cardNumberFieldSelector: "#cardNumber-container",
          cardPlaceholder: 'Enter Card Number #',
          cvvPlaceholder: 'Enter CVV #',
          css: `
                * {
                  box-sizing: border-box;
                  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
                }

                #cccardlabel, #cccvvlabel, #ccexpirylabel {
                  font-size: 13px !important;
                  font-family: sans-serif;
                  font-weight: 600 !important;
                  color: #444444;
                  margin-bottom: 6px !important;
                  text-transform: uppercase;
                  letter-spacing: 0.04em;
                }

                input {
                  border: none;
                  border-bottom: 1.5px solid #d1d5db;
                  border-radius: 0;
                  font-family: sans-serif;
                  font-weight: 500;
                  font-size: 15px;
                  color: #1d1d1e;
                  padding: 10px 0;
                  width: stretch;
                  background: transparent;
                  margin: 4px 0 16px 0;
                  letter-spacing: 0.12em;
                }

                input::placeholder {
                  color: #c0c0c0;
                  letter-spacing: 0.06em;
                }

                input:focus {
                  outline: none !important;
                  border-bottom-color: #7c3aed;
                }

                select {
                      border: 1px solid #ced4da;
                      border-radius: 10px;
                      font-family: sans-serif;
                      font-weight: 500;
                      font-size: 14px;
                      color: #6b7280;
                      padding: 10px 14px;
                      margin: 4px 0 16px 0;
                      background-color: #fff;
                      appearance: auto;
                      cursor: pointer;
                      min-width: 90px;
                  }

                select:focus {
                  outline: none !important;
                  border-color: #7c3aed;
                }

                iframe {
                  width: strech !important;
                  min-height: 250px !important;
                }
              `
        });

        // Capture token automatically as user fills in card details
        this.runner.onTokenize((res: any) => {
          console.log('Auto tokenized:', res);
          this.isTokenizing = false;

          if (res.hasToken) {
            this.accountToken = res.token;
            const expiry = res.expiration || '';

            if (expiry.length >= 5) {
              const year = expiry.slice(0, 4);
              const month = expiry.slice(4);

              const formattedMonth = month.padStart(2, '0');
              const formattedYear = year.slice(-2);

              this.expiryFromRunner = `${formattedMonth}/${formattedYear}`;
              this.creditCardForm.patchValue({
                expirationDate: this.expiryFromRunner
              })
            } else {
              this.expiryFromRunner = '';
            }
          } else {
            this.accountToken = null; // Reset if tokenization failed
          }
        });

      }, 0);
    }
  }
  check(): void {
    if (this.accountToken) {
      return;
    }

    // Token not yet available — wait briefly for async tokenization to complete
    this.isTokenizing = true;
    clearTimeout(this.tokenizeTimeout);

    this.tokenizeTimeout = setTimeout(() => {
      this.isTokenizing = false;

      if (!this.accountToken) {
        this.toastr.info('Please enter correct card details to proceed.');
      }
    }, 1500); // Wait 1.5s for onTokenize to fire
  }
}
